import React from 'react';

const WelcomeBanner = ({ teacherName, activeClass }) => (
  <div className="flex items-center bg-gradient-to-r from-primary to-accent p-6 rounded-2xl mb-6 shadow-lg relative overflow-hidden">
    {/* Optional overlay for better contrast */}
    <div className="absolute inset-0 bg-black/10 md:bg-black/20 pointer-events-none rounded-2xl" />
    <div className="w-16 h-16 rounded-full bg-white flex items-center justify-center mr-4 border-4 border-primary text-primary text-3xl font-bold shadow relative z-10">
      {teacherName ? teacherName.charAt(0).toUpperCase() : "T"}
    </div>
    <div className="relative z-10">
      <h1 className="text-2xl md:text-3xl font-bold mb-1 text-white drop-shadow-lg">
        Welcome, <span className="text-accent-foreground">{teacherName}</span>!
      </h1>
      <p className="text-base md:text-lg text-white/90 drop-shadow">
        This is your teacher dashboard.<br />
        You are currently logged into <span className="font-semibold text-primary">{activeClass}</span>.
      </p>
    </div>
  </div>
);

export default WelcomeBanner;